import { render, staticRenderFns } from "./TaskReceiverSelector.vue?vue&type=template&id=3c520f9c&scoped=true&"
import script from "./TaskReceiverSelector.vue?vue&type=script&lang=js&"
export * from "./TaskReceiverSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskReceiverSelector.vue?vue&type=style&index=0&id=3c520f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c520f9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VIcon})
